'use strict';

const urls = {};

urls.production = {
  accounts: 'accounts.makerbot.com',
  assets: 'assets.makerbot.com',
  cloudauth: 'cloudauth.makerbot.com',
  cloudprint: 'print.makerbot.com',
  cloudslicer: 'cloudslicer.makerbot.com',
  digital: 'digitalstore.makerbot.com',
  force: 'makerbot.force.com',
  images: 'images.makerbot.com',
  mbcom: 'www.makerbot.com',
  myMakerBot: 'my.makerbot.com',
  onion: 'login.makerbot.com',
  rightSignature: 'signature.makerbot.com',
  reconstructor: 'reconstructor.makerbot.com',
  reflector: 'reflector.makerbot.com',
  secure: 'secure.makerbot.com',
  schemaSettings: 'schema-settings.makerbot.com',
  store: 'store.makerbot.com',
  subscribe: 'subscribe.makerbot.com',
  support: 'support.makerbot.com',
  teams: 'cloudprint.makerbot.com',
  thingiverseAccounts: 'accounts.thingiverse.com',
  thingiverseApi: 'api.thingiverse.com',
  tv: 'www.thingiverse.com',
  watchtower: 'watchtower.makerbot.com',
  converter: 'hoops.makerbot.com',
  digitalFactory: 'digitalfactory.ultimaker.com',
};

urls.staging = urls.test = {
  accounts: 'accounts.mbot.me',
  assets: 'assets.mbot.me',
  cloudauth: 'cloudauth.mbot.me',
  cloudprint: 'print.mbot.me',
  cloudslicer: 'cloudslicer-staging.makerbot.com',
  digital: 'digitalstore.mbot.me',
  mbcom: 'www.mbot.me',
  myMakerBot: 'my.mbot.me',
  onion: 'login.mbot.me',
  rightSignature: 'signature.makerbot.com',
  reconstructor: 'reconstructor.mbot.me',
  reflector: 'reflector-staging.makerbot.com',
  secure: 'secure.mbot.me',
  schemaSettings: 'schema-settings.mbot.me',
  store: 'store.mbot.me',
  subscribe: 'subscribe.mbot.me',
  support: 'support.mbot.me',
  teams: 'cloudprint.mbot.me',
  thingiverseAccounts: 'accounts-staging.thingiverse.com',
  thingiverseApi: 'api-staging.thingiverse.com',
  tv: 'staging.thingiverse.com',
  watchtower: 'watchtower-staging.makerbot.com',
  converter: 'hoops.mbot.me',
  digitalFactory: 'digitalfactory-staging.ultimaker.com',
};

urls.dev = urls.development = {
  accounts: 'accounts.mbot.dev',
  assets: 'assets.mbot.dev',
  cloudauth: 'cloudauth.mbot.dev',
  cloudprint: 'print.mbot.dev',
  cloudslicer: 'cloudslicer-dev.makerbot.com',
  digital: 'digitalstore.mbot.dev',
  mbcom: 'www.mbot.dev',
  myMakerBot: 'my.mbot.dev',
  // Here, we're using the production version for now, because this site relies
  // on databases with dependencies that make them difficult to just port over
  onion: 'login.mbot.dev',
  rightSignature: 'signature.makerbot.com',
  reconstructor: 'reconstructor.mbot.dev',
  reflector: 'reflector-dev.makerbot.com',
  secure: 'secure.mbot.dev',
  schemaSettings: 'schema-settings.mbot.dev',
  store: 'store.mbot.dev',
  subscribe: 'subscribe.mbot.dev',
  support: 'support.mbot.dev',
  // Ditto above comment
  teams: 'cloudprint.mbot.dev',
  thingiverseAccounts: 'accounts-dev.thingiverse.com',
  thingiverseApi: 'api-dev.thingiverse.com',
  // Ditto above comment
  tv: 'www.thingiverse.com',
  watchtower: 'watchtower-dev.makerbot.com',
  converter: 'hoops.mbot.me',
  // For now let's use the DF local url while we're getting things integrated
  digitalFactory: 'localhost:4100',
};

urls.internal = {
  production: {
    mbcom: 'prd-ecs-mbcom-1154390290.us-east-1.elb.amazonaws.com',
    store: 'prd-ecs-enterprise-1566178639.us-east-1.elb.amazonaws.com',
    assets: 'prd-ecs-assets-1900438469.us-east-1.elb.amazonaws.com',
    support: 'prd-ecs-mb-support-1925937958.us-east-1.elb.amazonaws.com',
  },
  staging: {
    mbcom: 'stg-ecs-mbcom-1635443960.us-east-1.elb.amazonaws.com',
    store: 'stg-ecs-enterprise-81369562.us-east-1.elb.amazonaws.com',
    assets: 'stg-ecs-assets-1691528419.us-east-1.elb.amazonaws.com',
    support: 'stg-ecs-mb-support-169456579.us-east-1.elb.amazonaws.com',
  }
};

class URLs {
  constructor() {
    this.set(process.env.NODE_ENV || 'production');
  }

  set(env, internal) {
    // use production as default set and override with defined values for given environment
    internal = internal ? urls.internal[env] : null;
    const urlSet = Object.assign({}, urls.production, urls[env], internal);
    for (let site in urlSet) {
      const envKey = `URL_${site.toUpperCase()}`;
      // For apps such as cloudprint that are build using the create-react-app package,
      // which only accept custom environment variables that have the "REACT_APP_" prefix
      const reactEnvKey = `REACT_APP_URL_${site.toUpperCase()}`;
      this[site] = process.env[envKey] || process.env[reactEnvKey] || urlSet[site];
    }
    this.env = env;
  }

  /**
   * Get a specific URL via string and potentially prepending the protocol in the scheme if protocol is set
   *
   * @param {string} urlKey   Gets the specific URL by its property name on the returned url object
   * @param {string} protocol Protocol to be used. For example, 'http' or 'https'
   * @returns {*}
   */
  get(urlKey, protocol) {
    protocol = (typeof protocol === 'undefined') ? undefined : protocol.replace(/(:\/\/)$/, '');
    return (!protocol) ? this[urlKey] : protocol + '://' + this[urlKey];
  }

  useInternal() {
    this.set(this.env, true);
  }

  toJSON() {
    const obj = Object.assign({}, this);
    delete obj.env;
    return obj;
  }
}

module.exports = new URLs();
